import { deepMerge } from "grommet/utils";

/*
excludeProps = {
    valueInProps1: valueInProps2
    image: 'color'
}
*/
export const mergeProps = (props1, props2, excludeProps = {}) => {
    // const newProps = { ...props1, ...props2 };

    const newProps = deepMerge(props1, props2);

    for (const [valueInProps1, valueInProps2] of Object.entries(excludeProps)) {
        if (props2.hasOwnProperty(valueInProps2)) {
            delete newProps[valueInProps1];
        }
    }

    return newProps;
}